import { getOrderContentColumnScrollEl } from "./orderMealsScrollChaining";
import { getOrderMealsListScrollEl } from "./orderMealsScrollportLayout";

/** Meal list on wide layout (`.order-body-scroll` when capped). Footer: `.content-column` + orderMealsScrollChaining.ts. */
export function getOrderAppScrollRoot(): HTMLElement | null {
    return getOrderMealsListScrollEl() || document.getElementById('app');
}

export function scrollOrderAppContentToTop(): void {
    const scrollRoot = getOrderAppScrollRoot();
    scrollRoot?.scrollTo(0, 0);
    getOrderContentColumnScrollEl()?.scrollTo(0, 0);
    document.getElementById('app')?.scrollTo(0, 0);
    window.scrollTo(0, 0);
}

function getOrderStickyChromeHeight(): number {
    const header = document.querySelector('#orderApp > .header') as HTMLElement | null;
    const daySelector = document.querySelector('#orderApp .day-selector') as HTMLElement | null;
    return (header?.getBoundingClientRect().height ?? 80) + (daySelector?.getBoundingClientRect().height ?? 94);
}

/** Scroll so the selected day's content starts at the top of the scrollport (day strip stays pinned on mobile). */
export function scrollOrderDayContentIntoView(): void {
    const scrollRoot = getOrderAppScrollRoot();
    const anchor = document.getElementById('order-day-content-start');
    if (!scrollRoot || !anchor) {
        scrollOrderAppContentToTop();
        return;
    }
    const usesInnerOrderScroll =
        scrollRoot.classList.contains('order-meals-scrollport') ||
        scrollRoot.classList.contains('order-body-scroll');
    const stickyChrome = usesInnerOrderScroll ? 0 : getOrderStickyChromeHeight();
    const rootRect = scrollRoot.getBoundingClientRect();
    const anchorRect = anchor.getBoundingClientRect();
    const targetTop = scrollRoot.scrollTop + (anchorRect.top - rootRect.top) - stickyChrome;
    scrollRoot.scrollTo({ top: Math.max(0, targetTop), behavior: 'auto' });
    window.scrollTo(0, 0);
}
